/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `MD` - MD
 * * `DO` - DO
 * * `DPM` - DPM
 * * `PA` - PA
 * * `NP` - NP
 * * `CNM` - CNM
 * * `CNS` - CNS
 * * `CRNA` - CRNA
 * * `DNP` - DNP
 * * `DDS` - DDS
 * * `DMD` - DMD
 * * `MBA` - MBA
 * * `MHA` - MHA
 * * `MPH` - MPH
 * * `PHD` - PhD
 */
export enum DegreeEnum {
    MD = 'MD',
    DO = 'DO',
    DPM = 'DPM',
    PA = 'PA',
    NP = 'NP',
    CNM = 'CNM',
    CNS = 'CNS',
    CRNA = 'CRNA',
    DNP = 'DNP',
    DDS = 'DDS',
    DMD = 'DMD',
    MBA = 'MBA',
    MHA = 'MHA',
    MPH = 'MPH',
    PHD = 'PHD',
}
